/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Alerts_Types_Threshold_DescriptionInputs */

const es_billing_alerts_types_threshold_description = /** @type {(inputs: Billing_Alerts_Types_Threshold_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se enviará una notificación cuando el gasto mensual alcance el monto configurado.`)
};

const en_billing_alerts_types_threshold_description = /** @type {(inputs: Billing_Alerts_Types_Threshold_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A notification will be sent when the monthly spend reaches the configured amount.`)
};

/**
* | output |
* | --- |
* | "A notification will be sent when the monthly spend reaches the configured amount." |
*
* @param {Billing_Alerts_Types_Threshold_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_alerts_types_threshold_description = /** @type {((inputs?: Billing_Alerts_Types_Threshold_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Alerts_Types_Threshold_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_alerts_types_threshold_description(inputs)
	return en_billing_alerts_types_threshold_description(inputs)
});
export { billing_alerts_types_threshold_description as "billing.alerts.types.threshold.description" }